import { localSort, setActiveFilters, applyFilters, resetFilters, selectedValues } from 'snippets/plp-native/@store'

function PlpNativeFilterApply({ localSelected, countFilterSelected }) {
  const { clearAll, applyFilter } = translate.collection

  const handleApplyFilters = () => {
    applyFilters(
      {
        selectedValues: localSelected,
        page: 1,
        sort_by: localSort.value
      },
      'filtering',
      true
    )
    setActiveFilters()
  }

  return (
    <div className="flex gap-5 p-5 border-t border-neutral-900">
      {countFilterSelected > 0 && (
        <button
          type="button"
          disabled={!Object.keys(selectedValues.value).length}
          onClick={() => resetFilters(true)}
          className="button-outlined w-full"
        >
          {clearAll}
        </button>
      )}
      <button type="button" onClick={handleApplyFilters} className="button-primary w-full">
        {applyFilter}
      </button>
    </div>
  )
}

export default PlpNativeFilterApply
